<template>
  <v-main>
    <v-container class="col-10 pa-0 py-10 ma-0-auto page-wrapper">
      <v-btn to="/news" class="back-button green--text" text rounded large>
        <v-icon class="mr-3" size="24px">mdi-arrow-left</v-icon>
        {{ $t('News') }}
      </v-btn>

      <!-- HEADER -->
      <div class="mt-10 mb-5">
        <div v-if="$i18n.locale === 'en'">
          <h1 class="show-title">{{ article.titleEn }}</h1>
        </div>
        <div v-if="$i18n.locale === 'pt'">
          <h1 class="show-title">{{ article.titlePt }}</h1>
        </div>
        <span class="show-date">{{
          moment(article.data).format('DD MMMM YYYY')
        }}</span>
      </div>

      <div v-if="article" class="d-flex flex-column flex-lg-row">
        <!-- IMAGE -->
        <v-col class="col-12 col-md-8 mx-auto col-lg-4 pa-0">
          <img :src="getImageURI(article.image)" />
        </v-col>

        <!-- MAIN -->
        <v-col class="col-12 col-lg-8 pa-0 pl-lg-12">
          <div class="content-body">
            <vue-markdown v-show="$i18n.locale === 'en'">{{
              article.textEn
            }}</vue-markdown>
            <vue-markdown v-show="$i18n.locale === 'pt'">{{
              article.textPt
            }}</vue-markdown>
          </div>
        </v-col>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'ArticlePage',
  components: { VueMarkdown },
  data() {
    return {
      article: this.getArticle(),
    }
  },
  methods: {
    getArticle() {
      const query = {
        query: this.$route.params.slug,
      }

      this.$contentful.getEntries(query).then(res => {
        this.article = ''
        if (res.items.length) {
          this.article = res.items[0].fields
        }
      })
    },

    getImageURI(image) {
      if (image && image.fields && image.fields.file && image.fields.file.url) {
        return image.fields.file.url
      }

      return 'https://cdn.vuetifyjs.com/images/cards/house.jpg'
    },
  },
}
</script>

<style>
img {
  width: 100%;
}
</style>
